import {
  MANUFACTURERS_CLEAR_ENTITIES,
  MANUFACTURERS_CREATE_ENTITY,
  MANUFACTURERS_DELETE_ENTITY,
  MANUFACTURERS_EDIT_ENTITY,
  MANUFACTURERS_FETCH_ALL_ENTITIES,
  MANUFACTURERS_FETCH_ENTITIES,
  MANUFACTURERS_FETCH_ENTITIES_CATALOG,
  MANUFACTURERS_SET_PAGE,
  MANUFACTURERS_SET_ROWS_PER_PAGE
} from "../action-types/manufacturers-types";
import ColumnInterface from "../../interfaces/column";
import AppConstants from "../../AppConstants";

type Manufacturer = {
  id: number;
  name: string;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
};

const columns: ColumnInterface[] = [
  {
    id: 'id',
    label: 'Manufacturer #',
    minWidth: 170,
    align: 'left',
  },
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'action', label: 'Action', align: 'left' },
];
const initialState = {
  entities: [],
  entitiesCatalog: [],
  loading: false,
  loaded: false,
  columns,
  paginationConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
  paginationCatalogConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MANUFACTURERS_FETCH_ENTITIES.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        entities: [],
      };
    case MANUFACTURERS_FETCH_ENTITIES.SUCCESS:
      return {
        ...state,
        entities: action.payload.data.manufacturers,
        paginationConfig: {
          ...state.paginationConfig,
          total: action.payload.data.pagination.total,
        },
        loading: false,
        loaded: true,
      };
    case MANUFACTURERS_FETCH_ALL_ENTITIES.REQUEST: {
      return {
        ...state,
        loading: false,
        entitiesCatalog: [],
      };
    }
    case MANUFACTURERS_FETCH_ALL_ENTITIES.SUCCESS: {
      return {
        ...state,
        entitiesCatalog: [
          ...state.entitiesCatalog.filter(entity => entity),
          ...action.payload.data.manufacturers,
        ],
      };
    }
    case MANUFACTURERS_FETCH_ENTITIES_CATALOG.SUCCESS:
      return {
        ...state,
        entitiesCatalog: action.payload.data.manufacturers,
        paginationCatalogConfig: {
          ...state.paginationCatalogConfig,
          total: action.payload.data.pagination.total,
        },
        loading: false,
        loaded: true,
      };
    case MANUFACTURERS_DELETE_ENTITY.REQUEST:
    case MANUFACTURERS_CREATE_ENTITY.REQUEST:
    case MANUFACTURERS_EDIT_ENTITY.REQUEST:
    case MANUFACTURERS_CREATE_ENTITY.REJECTED:
    case MANUFACTURERS_FETCH_ALL_ENTITIES.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case MANUFACTURERS_FETCH_ENTITIES.REJECTED:
      return {
        ...state,
        entities: [],
        loading: false,
        loaded: true,
      };
    case MANUFACTURERS_CLEAR_ENTITIES:
      return {
        ...state,
        entities: [],
        loading: false,
        loaded: false,
      };

    case MANUFACTURERS_CREATE_ENTITY.SUCCESS:
      const newEntities = [...state.entities];

      if (state.entities.length === state.paginationConfig.rowsPerPage) {
        newEntities.pop();
      }

      return {
        ...state,
        entities: [action.payload.data, ...newEntities],
        paginationConfig: {
          ...state.paginationConfig,
          total: state.paginationConfig.total + 1,
        },
        loading: false,
      };
    case MANUFACTURERS_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case MANUFACTURERS_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };

    case MANUFACTURERS_EDIT_ENTITY.SUCCESS:
      return {
        ...state,
        entities: [
          ...state.entities.map((entity: Manufacturer) => {
            if (action.payload.id === entity.id) {
              return { ...entity, status: action.payload.status };
            }
            return entity;
          }),
        ],
        loading: false,
      };

    case MANUFACTURERS_DELETE_ENTITY.SUCCESS:
      return {
        ...state,
        entities: [
          ...state.entities.filter(
            (e: Manufacturer) => e.id !== action.payload,
          ),
        ],
        loading: false,
      };
    default:
      return state;
  }
}
